import Proto from './Proto';

class GrouponHeight extends Proto {

  get largeInfoHeight() {
	if (this.config.goods_list_style === 2) return 0;
	const {show_price: show_price, show_origin_price, show_buy_btn, show_title, text_align_type} = this.config;
	let height = 42;
	if (show_title) {
	  height += 25;
	}
	if (text_align_type === "center") {
	  if (show_price || show_origin_price) {
		height += 20;
	  }
	  if (show_buy_btn) {
		height += 35;
	  }
	  if (show_price || show_origin_price || show_buy_btn) {
		height += 5;
	  }
	}
	else {
	  if (show_price || show_origin_price || show_buy_btn) {
		height += 35;
	  }
	}

	// 有标题及价格时,加上padding10
	if (height !== 42) {
	  height += 10;
	}
	// console.log('get large info height', height);
	return height;
  }

  get smallInfoHeight() {
	if (this.config.goods_list_style === 2) return 0;
	const {show_price: show_price, show_origin_price, show_buy_btn, show_title, text_align_type} = this.config;
	let height = 24;
	if (show_title) {
	  height += 48;
	}
	if (text_align_type === "center") {
	  if (show_price || show_origin_price) {
		height += 20;
	  }
	  if (show_buy_btn) {
		height += 35;
	  }
	  if (![24, 72].includes(height)) {
		height += 5;
	  }
	}
	else {
	  if (show_price || show_origin_price || show_buy_btn) {
		height += 35;
	  }
	}
	// 有标题及价格时,加上padding10
	if (height !== 24) {
	  height += 10;
	}
	// console.log('get small info height', height);
	return height;
  }
}

export default function ({count, config}) {
  return new GrouponHeight({count, config}).totalHeight;
}
